/** `security` module DTOs unique keys */
export enum SecurityDtoKeysEnum {
  /** Application access control settings full data response body */
  APPLICATION_ACCESS_CONTROL_FULL_FIND_DTO = 'security/application-access-control-full-find.dto',
  /** Application access control settings response body for rate plan find APIs */
  APPLICATION_ACCESS_CONTROL_RATE_PLAN_FIND_DTO = 'security/application-access-control-rate-plan-find.dto',
  /** Application access control settings request body for rate plan create/update APIs */
  APPLICATION_ACCESS_CONTROL_RATE_PLAN_FORM_DTO = 'security/application-access-control-rate-plan-form.dto',
  /** Application access control settings request body for role create/update APIs */
  APPLICATION_ACCESS_CONTROL_ROLE_FORM_DTO = 'security/application-access-control-role-form.dto',
  /** Application module base data response body */
  APPLICATION_MODULE_BASE_DTO = 'security/application-module-base.dto',
  /** Application module full data response body */
  APPLICATION_MODULE_FULL_FIND_DTO = 'security/application-module-full-find.dto',
  /** Application module resonse body for rate plan find APIs */
  APPLICATION_MODULE_RATE_PLAN_FIND_DTO = 'security/application-module-rate-plan-find.dto',
  /** Application module request body for rate plan create/update APIs */
  APPLICATION_MODULE_RATE_PLAN_FORM_DTO = 'security/application-module-rate-plan-form.dto',
  /** Application module request body for role create/update APIs */
  APPLICATION_MODULE_ROLE_FORM_DTO = 'security/application-module-role-form.dto',
  /** Application section's permission data response body */
  APPLICATION_PERMISSION_FIND_DTO = 'security/application-permission-find.dto',
  /** Application section's permission request body for role create/update APIs */
  APPLICATION_PERMISSION_FORM_DTO = 'security/application-permission-form.dto',
  /** Application section base data response body */
  APPLICATION_SECTION_BASE_DTO = 'security/application-section-base.dto',
  /** Application section full data response body */
  APPLICATION_SECTION_FULL_FIND_DTO = 'security/application-section-full-find.dto',
  /** Application section response body for rate plan find APIs */
  APPLICATION_SECTION_RATE_PLAN_FIND_DTO = 'security/application-section-rate-plan-find.dto',
  /** Application section request body for rate plan create/update APIs */
  APPLICATION_SECTION_RATE_PLAN_FORM_DTO = 'security/application-section-rate-plan-form.dto',
  /** Application section request body for role create/update APIs */
  APPLICATION_SECTION_ROLE_FORM_DTO = 'security/application-section-role-form.dto',
  /** Appication section's tab base data response body */
  APPLICATION_TAB_BASE_DTO = 'security/application-tab-base.dto',
  /** Appication section's tab full data response body */
  APPLICATION_TAB_FULL_FIND_DTO = 'security/application-tab-full-find.dto',
  /** Appication section's tab response body for rate plan find APIs */
  APPLICATION_TAB_RATE_PLAN_FIND_DTO = 'security/application-tab-rate-plan-find.dto',
  /** Appication section's tab request body for rate plan create/update APIs */
  APPLICATION_TAB_RATE_PLAN_FORM_DTO = 'security/application-tab-rate-plan-form.dto',
  /** Appication section's tab request body for role create/update APIs */
  APPLICATION_TAB_ROLE_FORM_DTO = 'security/application-tab-role-form.dto',
  /** Appication section's tab request and response body */
  APPLICATION_TAB_DTO = 'security/application-tab.dto',
  /** Personal account menu response body */
  PERSONAL_ACCOUNT_MENU_FIND_DTO = 'security/personal-account-menu-find.dto',
  /** Personal account menu write request body */
  PERSONAL_ACCOUNT_MENU_FORM_DTO = 'security/personal-account-menu-form.dto',
  /** Personal account mode menu item response body */
  PERSONAL_ACCOUNT_MENU_ITEM_FIND_DTO = 'security/personal-account-menu-item-find.dto',
  /** Personal account mode menu item write request body */
  PERSONAL_ACCOUNT_MENU_ITEM_FORM_DTO = 'security/personal-account-menu-item-form.dto',
  /** External user access control settings common request and response body */
  EXTERNAL_USER_ACCESS_CONTROL_DTO = 'security/external-user-access-control.dto',
  /** External user create request body */
  EXTERNAL_USER_CREATE_DTO = 'security/external-user-create.dto',
  /** External user response body */
  EXTERNAL_USER_FIND_DTO = 'security/external-user-find.dto',
  /** External users flat list API query parameters */
  EXTERNAL_USER_FLAT_LIST_QUERY_DTO = 'security/external-user-flat-list-query.dto',
  /** External user create/update request body */
  EXTERNAL_USER_FORM_DTO = 'security/external-user-form.dto',
  /** External user invite API query parameters */
  EXTERNAL_USER_INVITE_ONE_QUERY_DTO = 'security/external-user-invite-one-query.dto',
  /** INN client registration lookup request body */
  INN_CLIENT_REGISTRATION_LOOKUP_FORM_DTO = 'security/inn-client-registration-lookup-form.dto',
  /** INN client registration lookup response body */
  INN_CLIENT_REGISTRATION_LOOKUP_FIND_DTO = 'security/inn-client-registration-lookup-find.dto',
  /** INN client registration complete request body */
  INN_CLIENT_REGISTRATION_COMPLETE_FORM_DTO = 'security/inn-client-registration-complete-form.dto',
  /** External users list APIs filters */
  EXTERNAL_USER_LIST_FILTERS_DTO = 'security/external-user-list-filters.dto',
  /** External user list API column selection */
  EXTERNAL_USER_SELECT_DTO = 'security/external-user-select.dto',
  /** External user list API sorting */
  EXTERNAL_USER_SORT_DTO = 'security/external-user-sort.dto',
  /** External users pagination list API query parameters */
  EXTERNAL_USER_PAGE_LIST_QUERY_DTO = 'security/external-user-page-list-query.dto',
  /** External users pagination list API response body */
  EXTERNAL_USER_PAGE_DTO = 'security/external-user-page.dto',
  /** External users BASIS registry column selection */
  EXTERNAL_USER_REGISTRY_SELECT_DTO = 'security/external-user-registry-select.dto',
  /** External users BASIS registry filters */
  EXTERNAL_USER_REGISTRY_FILTERS_DTO = 'security/external-user-registry-filters.dto',
  /** External users BASIS registry sorting */
  EXTERNAL_USER_REGISTRY_SORT_DTO = 'security/external-user-registry-sort.dto',
  /** External users BASIS registry query */
  EXTERNAL_USER_REGISTRY_QUERY_DTO = 'security/external-user-registry-query.dto',
  /** External users BASIS registry page response */
  EXTERNAL_USER_REGISTRY_PAGE_DTO = 'security/external-user-registry-page.dto',
  /** External user list API response body (personal account registry v2) */
  EXTERNAL_USER_LK_PAGE_DTO = 'security/external-user-lk-page.dto',
  /** External user partial update API request body */
  EXTERNAL_USER_PARTIAL_FORM_DTO = 'security/external-user-partial-form.dto',
  /** External user create request body for personal account mode */
  EXTERNAL_USER_LK_CREATE_DTO = 'security/external-user-lk-create.dto',
  /** External user create/update request body for personal account mode */
  EXTERNAL_USER_LK_FORM_DTO = 'security/external-user-lk-form.dto',
  /** External user partial update API request body for personal account mode */
  EXTERNAL_USER_LK_PARTIAL_FORM_DTO = 'security/external-user-lk-partial-form.dto',
  /** External users list filters for personal account mode */
  EXTERNAL_USER_LK_LIST_FILTERS_DTO = 'security/external-user-lk-list-filters.dto',
  /** External users list filters for personal account mode without select */
  EXTERNAL_USER_LK_LIST_FILTERS_WITHOUT_SELECT_DTO = 'security/external-user-lk-list-filters-without-select.dto',
  /** External users list select for personal account mode */
  EXTERNAL_USER_LK_LIST_SELECT_DTO = 'security/external-user-lk-list-select.dto',
  /** External users flat list API query parameters for personal account mode */
  EXTERNAL_USER_LK_FLAT_LIST_QUERY_DTO = 'security/external-user-lk-flat-list-query.dto',
  /** External users pagination list API query parameters for personal account mode */
  EXTERNAL_USER_LK_QUERY_DTO = 'security/external-user-lk-query.dto',
  USER_CHANGE_PASSWORD_DTO = 'security/user-change-password.dto',
  USER_DELETE_QUERY_DTO = 'security/user-delete-query.dto',
  USER_EMAIL_DTO = 'security/user-email.dto',
  USER_FIND_DTO = 'security/user-find.dto',
  USER_LOGIN_RESPONSE_DTO = 'security/user-login-response.dto',
  USER_LOGIN_DTO = 'security/user-login.dto',
  USER_NEED_DELEGATE_DTO = 'security/user-need-delegate.dto',
  USER_FORM_DTO = 'security/user-form.dto',
  USER_CREATE_DTO = 'security/user-create.dto',
  USER_UPDATE_DTO = 'security/user-update.dto',
  WORK_SCHEDULE_HOURS_DTO = 'security/work-schedule-hours.dto',
  WORK_SCHEDULE_FORM_DTO = 'security/work-schedule.form.dto',
  WORK_SCHEDULE_FIND_DTO = 'security/work-schedule.find.dto',
  /** Work schedules BASIS registry column selection */
  WORK_SCHEDULE_REGISTRY_SELECT_DTO = 'security/work-schedule-registry-select.dto',
  /** Work schedules BASIS registry sorting */
  WORK_SCHEDULE_REGISTRY_SORT_DTO = 'security/work-schedule-registry-sort.dto',
  /** Work schedules BASIS registry API query */
  WORK_SCHEDULE_REGISTRY_QUERY_DTO = 'security/work-schedule-registry-query.dto',
  /** Work schedules BASIS registry API response */
  WORK_SCHEDULE_REGISTRY_PAGE_DTO = 'security/work-schedule-registry-page.dto',
  /** Profile change password request body */
  PROFILE_CHANGE_PASSWORD_DTO = 'security/profile-change-password.dto',
  /** Profile response body */
  PROFILE_FIND_DTO = 'security/profile-find.dto',
  /** Profile flat list API query parameters */
  PROFILE_FLAT_LIST_QUERY_DTO = 'security/profile-flat-list-query.dto',
  /** Profile create/update request body */
  PROFILE_FORM_DTO = 'security/profile-form.dto',
  /** Profiles list APIs filters */
  PROFILE_LIST_FILTERS_DTO = 'security/profile-list-filters.dto',
  /** Profiles pagination list API response body */
  PROFILE_LIST_PAGE_DTO = 'security/profile-list-page.dto',
  /** Profile login API response body */
  PROFILE_LOGIN_FIND_DTO = 'security/profile-login-find.dto',
  /** Profile login API request body */
  PROFILE_LOGIN_FORM_DTO = 'security/profile-login-form.dto',
  /** Profile paginated list API query parameters */
  PROFILE_PAGE_LIST_QUERY_DTO = 'security/profile-page-list-query.dto',
  /** New profile register API request body */
  PROFILE_REGISTER_DTO = 'security/profile-register.dto',
  /** Profile password reset API request body */
  PROFILE_RESET_PASSWORD_DTO = 'security/profile-reset-password.dto',
  /** Profile email test API response body */
  PROFILE_TEST_EMAIL_FIND_DTO = 'security/profile-test-email-find.dto',
  /** Profile email test API query parameters */
  PROFILE_TEST_EMAIL_QUERY_DTO = 'security/profile-test-email-query.dto',
  /** Role response body */
  ROLE_FIND_DTO = 'security/role-find.dto',
  /** Role create and update APIs request body */
  ROLE_FORM_DTO = 'security/role-form.dto',
  /** Roles list API query parameters */
  ROLE_QUERY_DTO = 'security/role-query.dto',
  /** Roles BASIS registry column selection */
  ROLE_REGISTRY_SELECT_DTO = 'security/role-registry-select.dto',
  /** Roles BASIS registry sorting */
  ROLE_REGISTRY_SORT_DTO = 'security/role-registry-sort.dto',
  /** Roles BASIS registry API query */
  ROLE_REGISTRY_QUERY_DTO = 'security/role-registry-query.dto',
  /** Roles BASIS registry API response */
  ROLE_REGISTRY_PAGE_DTO = 'security/role-registry-page.dto',
  USER_GROUP_MEMBER_FIND_DTO = 'security/user-group-member-find.dto',
  USER_GROUP_FIND_DTO = 'security/user-group-find.dto',
  USER_GROUP_FORM_DTO = 'security/user-group-form.dto',
  /** User groups BASIS registry column selection */
  USER_GROUP_REGISTRY_SELECT_DTO = 'security/user-group-registry-select.dto',
  /** User groups BASIS registry sorting */
  USER_GROUP_REGISTRY_SORT_DTO = 'security/user-group-registry-sort.dto',
  /** User groups BASIS registry API query */
  USER_GROUP_REGISTRY_QUERY_DTO = 'security/user-group-registry-query.dto',
  /** User groups BASIS registry API response */
  USER_GROUP_REGISTRY_PAGE_DTO = 'security/user-group-registry-page.dto',
  USER_FIND_QUERY_DTO = 'security/user-find-query.dto',
  /** Internal users BASIS registry column selection */
  USER_REGISTRY_SELECT_DTO = 'security/user-registry-select.dto',
  /** Internal users BASIS registry kind filter */
  USER_REGISTRY_KIND_DTO = 'security/user-registry-kind.dto',
  /** Internal users BASIS registry dropdown / list filters */
  USER_REGISTRY_LIST_FILTERS_DTO = 'security/user-registry-list-filters.dto',
  /** Internal users BASIS registry filters */
  USER_REGISTRY_FILTERS_DTO = 'security/user-registry-filters.dto',
  /** Internal users BASIS registry sorting */
  USER_REGISTRY_SORT_DTO = 'security/user-registry-sort.dto',
  /** Internal users BASIS registry API query */
  USER_REGISTRY_QUERY_DTO = 'security/user-registry-query.dto',
  /** Internal users BASIS registry API response */
  USER_REGISTRY_PAGE_DTO = 'security/user-registry-page.dto',
  USER_LIST_FIND_DTO = 'security/user-list-find.dto',
  USER_FIND_ALL_QUERY_DTO = 'security/user-find-all-query.dto',
  /** Room access settings for user or group (response body) */
  ROOM_ACCESS_FIND_DTO = 'security/room-access-find.dto',
  /** Room access settings for user or group (create/update request body) */
  ROOM_ACCESS_FORM_DTO = 'security/room-access-form.dto',
  /** Access control rule for current authorized user */
  ACCESS_CONTROL_RULE_DTO = 'security/access-control-rule.dto',
  /** Base metadata for access control units (modules, groups and APIs) */
  ACCESS_CONTROL_UNIT_DTO = 'security/access-control-unit.dto',
  /** Access control permission for concrete business logic action */
  ACCESS_CONTROL_PERMISSION_DTO = 'security/access-control-permission.dto',
  /** Logical group of APIs. It can also contain child groups. */
  GROUP_FIND_DTO = 'security/group-find.dto',
  /** A module is the top level division of an application's APIs */
  MODULE_FIND_DTO = 'security/module-find.dto',
  /** User delegation own filters */
  USER_DELEGATION_FILTERS_DTO = 'security/user-delegation-filters.dto',
  /** User delegation find many API query parameters */
  USER_DELEGATION_FIND_MANY_QUERY_DTO = 'security/user-delegation-find-many-query.dto',
  /** User delegation find one API query parameters (additional options) */
  USER_DELEGATION_FIND_ONE_QUERY_DTO = 'security/user-delegation-find-one-query.dto',
  /** User delegation response body */
  USER_DELEGATION_FIND_DTO = 'security/user-delegation-find.dto',
  /** User delegation created and update APis request body */
  USER_DELEGATION_FORM_DTO = 'security/user-delegation-form.dto',
  /** User delegation find many API response body */
  USER_DELEGATION_PAGE_DTO = 'security/user-delegation-page.dto',
  /** User delegation partial update API request body */
  USER_DELEGATION_PARTIAL_FORM_DTO = 'security/user-delegation-partial-form.dto',
  /** User delegation fields selection settings */
  USER_DELEGATION_SELECT_DTO = 'security/user-delegation-select.dto',
  /** User delegation sorting settings */
  USER_DELEGATION_SORT_DTO = 'security/user-delegation-sort.dto',
  /** Abstract "member" (user or user group) response body */
  MEMBER_FIND_DTO = 'security/member-find.dto',
}
